// components/StreamingMessage.tsx — ported from docs/superpowers/design-2026-04-21/messages.jsx

import type { JSX } from 'react';
import { useTokens } from '../state/theme';
import { ProfMessage } from './ProfMessage';
import { StreamingDots } from './StreamingDots';

export function StreamingMessage(): JSX.Element {
  const tokens = useTokens();
  return (
    <ProfMessage>
      <div style={{
        display: 'inline-flex', alignItems: 'center', gap: 10,
        padding: '6px 2px',
      }}>
        <StreamingDots/>
        <span style={{
          fontSize: 13.5, color: tokens.textMuted,
          fontFamily: tokens.fonts.serif, fontStyle: 'italic',
        }}>Il Prof sta scrivendo…</span>
      </div>
    </ProfMessage>
  );
}
